import { type ChangeEvent, type KeyboardEvent, useState } from 'react';

import { Textfield } from '@/components/ui/Textfield';
import { Flex } from '@/new_src/view/components/Flex';
import { Text } from '@/new_src/view/components/Text';
import { translate } from '@/utils/LocaleUtil';

import { styled } from 'styled-components';

type GoToPageProps = {
  currentPage: number;
  totalPages: number;
  onPageChange(page: number): void;
};

export const GoToPage = ({ currentPage, totalPages, onPageChange }: GoToPageProps) => {
  const [inputValue, setInputValue] = useState(currentPage.toString());

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // 숫자만 입력 가능
    if (value === '' || /^\d+$/.test(value)) {
      setInputValue(value);
    }
  };

  const handlePageChange = () => {
    const pageNumber = parseInt(inputValue, 10);

    if (isNaN(pageNumber) || pageNumber < 1 || pageNumber > totalPages) {
      // 유효하지 않은 값은 현재 페이지로 리셋
      setInputValue(currentPage.toString());
      return;
    }

    onPageChange(pageNumber);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handlePageChange();
      (e.target as HTMLInputElement).blur();
    }
  };

  const handleBlur = () => {
    handlePageChange();
  };

  return (
    <Flex align="center" gap="2px">
      <AlignCenterTextField
        type="text"
        value={inputValue}
        size="sm"
        width="32px"
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        aria-label={translate('page')}
        withRemoveIcon={false}
      />
      <Text size="12px" lh="116%" lts="0" c="gray.7" fw={400}>
        /{totalPages} {translate('page')}
      </Text>
    </Flex>
  );
};

const AlignCenterTextField = styled(Textfield)`
  text-align: center;

  input {
    padding: 0;
    text-align: center;
    color: ${({ theme }) => theme.mantineColors.gray[8]};
    line-height: 160%;
    letter-spacing: -0.06px;
    font-weight: 400;
  }
`;
